import React from 'react';
import restApiClient from '../util/api/restApiClient';
import { AppSettingsResult } from '../../../types';

export default function useAppSettings(settingKey: string): AppSettingsResult {
    const [state, setState] = React.useState({ loading: true, data: undefined, error: undefined });
    const path = `/app-settings/user/${settingKey}`;

    const fetch = async url => {
        try {
            const response = await restApiClient.get(url);
            setState({ loading: false, data: response.data, error: undefined });
        } catch (error) {
            if (error && error.response && error.response.status >= 500) {
                setState({ loading: false, data: undefined, error });
            } else {
                setState({ loading: false, data: undefined, error: undefined });
            }
        }
    };

    const set = async data => {
        try {
            const response = await restApiClient.put(path, { settingKey, content: data });
            setState({ loading: false, data: response.data, error: undefined });
        } catch (error) {
            if (error && error.response && error.response.status >= 500) {
                setState({ loading: false, data: undefined, error });
            } else {
                setState({ loading: false, data: undefined, error: undefined });
            }
        }
    };

    React.useEffect(() => {
        fetch(path);
    }, [path]);

    return {
        data: state.data,
        loading: state.loading,
        error: state.error,
        refetch: () => fetch(path),
        set,
    };
}
